import { TailSpin } from "react-loader-spinner";

const Loader = () => {
  return <TailSpin color="#f40612" height={40} width={40} />;
};

export default Loader;
